export default __webpack_public_path__ + "static/media/PYPLUSD.4d03dbb1.svg";